import { render } from "./New-frame-in-collection.vue?vue&type=template&id=1e80d480&scoped=true"
import script from "./New-frame-in-collection.vue?vue&type=script&lang=js"
export * from "./New-frame-in-collection.vue?vue&type=script&lang=js"

import "./New-frame-in-collection.vue?vue&type=style&index=0&id=1e80d480&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e80d480"]])

export default __exports__